<template>
    <v-footer class="footer-bg">
        <v-container >
            <v-row>
                <v-col class="col-lg-6 col-sm-12 col-xs-12">
                    <v-card flat class="footer-bg">
                        <v-card-title class="card-title">Contact</v-card-title>
                        <v-card-text class="card-content" >
                            <v-progress-linear
                                color="deep-purple"
                                indeterminate
                                rounded
                                class="progress-bar-sm"
                                height="3"
                                v-if="agentLoader"
                            ></v-progress-linear>
                            <div class="agency-name">{{agent.agencyName}}</div>
                            <div>{{agent.agentName}}</div>
                            <div><a :href="'tel:' + agent.agentPhone">{{ formattedPhoneNumber }}</a></div>
                            <div><a :href="'mailto:' + agent.agentEmail">{{agent.agentEmail}}</a></div>
                            <div v-if="agent.OCDTCAvatar" class="agent_profile_photo avatar-spacing">
                                <v-img :aspect-ratio="1" :src="agent.OCDTCAvatar"></v-img>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col class="col-lg-6 col-sm-12 col-xs-12">
                    <v-card flat class="card-float-right footer-bg">
                        <v-card-title class="card-title card-title-nowrap">
                            Committed to protecting your life’s journey.
                        </v-card-title>
                        <v-card-text class="card-content ">
                            <v-row class="card-float-right">
                                <v-col class="col-8">
                                    <img src="../assets/logo_SFG_193x34.svg" alt="Symmetry Logo" class="logo-sfg" />
                                </v-col>
                                <v-col class="col-4 " >
                                    <img src="../assets/BBB Logo l Black.svg" alt="bb logo" class="logo-bbb" />
                                </v-col>
                            </v-row>

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card flat class="footer-bg">
                        <v-card-text class="card-content">
                            <div class="disclaimer-text">
                                <p class="mt-4 disclaimer-first-p">
                                    *The rates shown above are not final. All final life insurance approvals and actual quotes are subject to personal health history and carrier-specific underwriting guidelines. Your actual rates and
                                    quotes may vary, and the underwriting process may determine that your actual premium quotes are higher or lower than the rates shown above. You will have a chance
                                    to review and accept the terms and conditions of any insurance policy you may apply for before you are charged. Not all applicants will qualify.
                                </p>
                                <p class="mt-4">
                                    By providing your information and/or utilizing the Service
                                    (as defined in the <a target="_blank" class="link-brand" :href="tc_link">Terms & Conditions</a> and <a target="_blank" class="link-brand" :href="pp_link" >Privacy Policy</a>) and
                                    this Website (as defined in the <a target="_blank" class="link-brand" :href="tc_link">Terms & Conditions</a> and <a target="_blank" class="link-brand" :href="pp_link" >Privacy Policy</a>),
                                    you agree to this Website’s <a target="_blank" class="link-brand" :href="pp_link" >Privacy Policy</a> and <a target="_blank" class="link-brand" :href="tc_link">Terms & Conditions</a> and you
                                    consent to be contacted (by emails, telephone calls, text messages, SMS or other
                                    forms of electronic communication such as a mobile application’s push notifications to the
                                    contact information you provide) by Quility Insurance Holdings LLC, any one or more of its
                                    direct or indirect subsidiaries, sister companies, or parent companies, or any of their employees or
                                    independent contractors or other affiliates ("Quility"), regarding the Service (as defined in the <a target="_blank" class="link-brand" :href="tc_link">Terms & Conditions</a> and <a target="_blank" class="link-brand" :href="pp_link" >Privacy Policy</a>)
                                    generally as well as regarding news, special offers and general information about other goods, services and events
                                    which we offer that are similar to those that you have already purchased or inquired about.
                                </p>
                                <p class="mt-4">
                                    MLI083021349-1
                                </p>
                                <p class="mt-5">
                                    Copyright © 2020 Quility Holdings, LLC. All Rights Reserved. | <a target="_blank" class="link-brand" :href="pp_link" >Privacy Policy</a>
                                </p>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

        </v-container>
    </v-footer>
</template>

<script>

import quilityMixin from '@/mixins/quilityMixin';

export default {
    name: "OcFooter",
    mixins:[quilityMixin],
    data: () => ({
        tc_link:null,
        pp_link: null,
    }),
    computed:{
        formattedPhoneNumber() {
            if(!this.agent.agentPhone) {
                return null
            }

            const parts = this.agent.agentPhone.split("-")
            return `(${parts[0]}) ${parts[1]}-${parts[2]}`
        },
        agentLoader() {
            return this.agent == null || this.agent == undefined
        },
    },
    mounted() {
        if(typeof this.$route.query.redirect_url!='undefined') {
            this.tc_link = this.$route.query.redirect_url + '/terms-conditions/';
            this.pp_link = this.$route.query.redirect_url + '/privacy-policy/';
        }
    },
}
</script>

<style scoped>
    .footer-bg {
        background: #f5f5f5 !important;
    }

    .progress-bar-sm {
        width: 30%;
    }

    .agency-name {
        font-weight: bold;
    }

    .avatar-spacing {
        margin-top: 10px;
    }

    .card-float-right {
        float: right;
    }

    .card-title-nowrap {
        word-break: keep-all;
    }

    .logo-sfg {
        width: 95%;
    }

    .logo-bbb {
        height: 90%;
        float: right;
    }

    .disclaimer-text {
        opacity: 0.9;
        font-weight: 300;
    }

    .disclaimer-first-p {
        padding: 2rem 0 0 0;
        white-space: pre-wrap;
        word-break: keep-all;
    }

    .link-brand {
        color: #005851;
    }

    .card-title {
        font-family: Montserrat; color:#005851; font-weight: bold;
    }

    .card-content {
        font-family: Montserrat;
        color: #2F2F2F;
    }

    .agent_profile_photo {
        height: 150px;
        width: 150px;
        border-radius: 50% !important;
        border: 2px solid #E4E4E4;
        overflow: hidden;
        text-align: center;
        display: inline-block;
        position: relative;
        margin: 0 auto;
        background-color: white;
    }

    .agent_profile_photo img {
        width: auto;
        height: 150px;
        position: absolute;
        margin: 0 auto;
        bottom: 0;
        right: 0;

    }

</style>